import { render, staticRenderFns } from "./OpeningBalanceEquity.vue?vue&type=template&id=0484483f&scoped=true&"
import script from "./OpeningBalanceEquity.vue?vue&type=script&lang=js&"
export * from "./OpeningBalanceEquity.vue?vue&type=script&lang=js&"
import style0 from "./OpeningBalanceEquity.vue?vue&type=style&index=0&id=0484483f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0484483f",
  null
  
)

export default component.exports